<div *ngIf="conflict">
  <app-alert
    class="site-updated-alert"
    level="error"
    message="Sorry, a lead is no longer available. Please try again later.">
    <span class="tw-px-3 conflict-lead-button-span">
      <button
        mat-raised-button
        class="conflict-lead-button"
        (click)="ackNotAvailable.emit()">
        Ok
      </button>
    </span>
  </app-alert>
</div>
<div
  @animateIn
  @animateOut
  class="tw-justify-center tw-text-white tw-text-base claim-lead-bar tw-flex tw-py-4 tw-px-2 tw-items-center"
  *ngIf="claimRestrictions && user && nextAssignmentExists">
  <div *ngIf="(nextAssignmentExists || unattemptedRestrict() || unattemptedWarn()) && !conflict && !showCallNow">
    <span *ngIf="nextAssignmentExists && !claimDisabled()" class="tw-align-middle">
      <span class="tw-font-bold" *ngIf="!flagHighPriority">A New Lead Is Available!</span>
      <span *ngIf="flagHighPriority">A New High-Priority Lead Is Available!</span>
      <span class="tw-px-3">
        <button
          class="claim-lead-button"
          mat-raised-button
          [disabled]="claimDisabled() || loading"
          (click)="getNext.emit()"
          data-cy="claim-lead-button">
          <span *ngIf="!loading">Claim Lead</span>
          <mat-spinner
            diameter="24"
            style="display: inline-block; height: 24px; width: 24px"
            *ngIf="loading">
          </mat-spinner>
        </button>
      </span>
    </span>
    <span *ngIf="ipAddressRestrict()">You must be in the office to claim leads.</span>
    <span *ngIf="unattemptedRestrict()">
      Uh oh,
      <app-unattempted-dropdown [unattemptedLeads]="claimRestrictions?.unattemptedLeads">
        <span class="tw-text-blue-300">({{ claimRestrictions.unattemptedLeads.length }}) unattempted leads</span>
      </app-unattempted-dropdown>
      are blocking you from claiming new leads.
    </span>
    <span *ngIf="unattemptedWarn()">
      Starting soon,
      <app-unattempted-dropdown [unattemptedLeads]="claimRestrictions?.unattemptedLeads">
        <span class="tw-text-blue-300"> unattempted leads ({{ claimRestrictions.unattemptedLeads.length }})</span>
      </app-unattempted-dropdown>
      will block you from claiming new leads.
    </span>
    <span
      *ngIf="unattemptedRestrict() || unattemptedWarn()"
      class="tw-cursor-pointer tw-pl-1"
      (click)="refresh.emit()">
      <mat-icon class="tw-align-middle">refresh</mat-icon>
    </span>
  </div>
  <div *ngIf="showCallNow && !preventAutoDial()">
    Call will start in {{ (countDownTime < 10) ? ("0"+countDownTime) : countDownTime }} seconds...
    <span class="tw-px-3">
      <button
        mat-raised-button
        class="claim-lead-button"
        (click)="handleCallNow()"
        [disabled]="callInProgress()">
        Call Now
      </button>
    </span>
  </div>
  <div *ngIf="conflict && !showCallNow">
    The lead is no longer available :(
    <span class="tw-px-3">
      <button
        mat-raised-button
        class="claim-lead-button"
        (click)="ackNotAvailable.emit()">
        Ok
      </button>
    </span>
  </div>
</div>
